import { render, staticRenderFns } from "./ScanHeatmap.vue?vue&type=template&id=13b95010&scoped=true"
import script from "./ScanHeatmap.vue?vue&type=script&lang=js"
export * from "./ScanHeatmap.vue?vue&type=script&lang=js"
import style0 from "./ScanHeatmap.vue?vue&type=style&index=0&id=13b95010&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b95010",
  null
  
)

export default component.exports